import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn';

import App from './App.vue';
import router from './router';
import store from './store';


// 配置 axios 拦截器
import '@/utils/axios';

// 全局样式
import '@/assets/styles/index.scss';

const app = createApp(App);

// 使用 Element Plus
app.use(ElementPlus, {
  locale: zhCn
});


// 使用路由和状态管理
app.use(store);
app.use(router);

app.mount('#app');
